import { render, staticRenderFns } from "./logicset.vue?vue&type=template&id=2c11dbb9&scoped=true&"
import script from "./logicset.vue?vue&type=script&lang=js&"
export * from "./logicset.vue?vue&type=script&lang=js&"
import style0 from "./logicset.vue?vue&type=style&index=0&id=2c11dbb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c11dbb9",
  null
  
)

export default component.exports